import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";

import NotificationsManagementPage from "./Notification/NotificationManagementPage/NotificationsManagementPage";

export const AdminNotifications: IRoute[] = [
  {
    exact: true,
    path: "/platform/notifications",
    pageComponent: NotificationsManagementPage,
    title: "%NOTIFICATIONS% Management",
    menuType: "ADMIN_MAIN",
    privateRoute: true,
    permissions: [ "create-notification" ],
    icon: Icons.BELL
  }
];

export default [ ...AdminNotifications ];
